<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/**
 * Contenu du bouton Légende de l'en-tête : icône + nom, ou icône seule quand
 * légende et échelle sont repliées en un seul bouton. Partagé par le vrai
 * bouton et par sa copie invisible qui sert à mesurer la place nécessaire.
 */
defineProps<{
  name: string;
  compact: boolean;
}>();
</script>

<template>
  <PhosphorIcon name="swatches" :size="compact ? 18 : 16" />
  <span v-if="!compact" class="legend-name text-truncate">{{ name }}</span>
  <PhosphorIcon name="caret-down" :size="11" weight="fill" />
</template>

<style lang="scss" scoped>
.legend-name {
  max-width: 140px;
}
</style>
